import React, {Component} from 'react';
import {Dropdown, Button, Modal, Form, Icon, Card, Image, Message} from 'semantic-ui-react';

import DataService from "../../functions/DataService";
import Loading from "../extras/Loading";
import {PhotoProvider, PhotoView} from "react-photo-view";


class ViewImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
            loading: true,
            open_modal: false,
            id: this.props.id,
            url: this.props.url,
            close_viewer: false,
            viewer_is_open: false
        };
    }

    loadImages = () => {
        DataService.get(`${this.state.url}/${this.state.id}`, {}).then(images=>{
            this.setState({images, loading:false});
        })
    };

    openModal = () => {
        this.setState({open_modal:true, close_viewer: true})
        this.loadImages()
    }
    render() {
        return <React.Fragment>
            <br/>
            <a onClick={() => this.openModal()}><Icon name='picture' fitted/> Ver fotos</a>
            <Modal size='large' open={this.state.open_modal} onClose={() => this.setState({open_modal:false})}>
                <Modal.Header>Fotografías</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {this.state.loading ? <Loading/> : null}
                        {!this.state.loading && this.state.images.length === 0 ? <Message icon='bell' header='No hay información registrada'/> :<Card.Group itemsPerRow={4}>
                            <PhotoProvider>
                                {this.state.images.map((item, index) => (
                                    <PhotoView key={index} src={item['image']}>
                                        <Card raised key={item.id}>
                                            <Image src={`${item['image']}?tr=w-800`} height='120' style={{ objectFit: 'cover' }}/>
                                        </Card>
                                    </PhotoView>
                                ))}
                            </PhotoProvider>
                        </Card.Group>}
                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => this.setState({open_modal:false})}>
                        Cerrar
                    </Button>
                </Modal.Actions>
            </Modal>
        </React.Fragment>
    }
}

export default ViewImages;



// WEBPACK FOOTER //
// ./src/components/utils/ViewImages.js